import * as React from 'react';
import { StyledTabPanel } from './index.styled';
var TabPanel = function (_a) {
    var children = _a.children, value = _a.value, index = _a.index;
    return (React.createElement("div", { role: "tabpanel", hidden: value !== index, id: "tabpanel-" + index }, value === index && React.createElement(StyledTabPanel, null, children)));
};
var ɵ0 = TabPanel;
export default TabPanel;
export { ɵ0 };
